// extracted by mini-css-extract-plugin
export default {"loadingSVG":"loading_loadingSVG__PYgFI","spinner":"loading_spinner__T5Vye"};